module.exports = __webpack_public_path__ + "img/logo-ovo_qris-active.8f890d96.svg";